import { getFirestore, doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { auth } from "./firebase"; // Import Firebase Auth from your config file

const db = getFirestore(); // Initialize Firestore

// ✅ Function to Fetch User Data from Firestore
export const fetchUserData = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) return null;

  try {
    const userRef = doc(db, "users", currentUser.uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return userSnap.data(); // Return user data
    } else {
      console.warn("⚠️ User document does not exist.");
      return null;
    }
  } catch (error) {
    console.error("❌ Error fetching user data:", error);
    return null;
  }
};

// ✅ Function to Save an Order to Firestore
export const saveOrderToFirestore = async (orderData) => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  try {
    const userRef = doc(db, "users", currentUser.uid);
    await updateDoc(userRef, {
      orders: arrayUnion(orderData),
    });
    console.log("✅ Order saved successfully!");
  } catch (error) {
    console.error("❌ Error saving order:", error);
  }
};

// ✅ Function to Save a Subscription to Firestore
export const saveSubscriptionToFirestore = async (subscriptionData) => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  try {
    const userRef = doc(db, "users", currentUser.uid);
    await updateDoc(userRef, {
      subscription: subscriptionData,
    });
    console.log("✅ Subscription saved successfully!");
  } catch (error) {
    console.error("❌ Error saving subscription:", error);
  }
};

// ✅ Update Address in Firestore
export const updateUserAddress = async (updatedAddress) => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  const userRef = doc(db, "users", currentUser.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) return;

  const addresses = userSnap.data().addresses || [];
  const updatedAddresses = addresses.map((addr) =>
    addr.id === updatedAddress.id ? updatedAddress : addr
  );

  await updateDoc(userRef, { addresses: updatedAddresses });
  return updatedAddresses;
};

// ✅ Delete Address from Firestore
export const deleteUserAddress = async (addressId) => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  const userRef = doc(db, "users", currentUser.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) return;

  const updatedAddresses = userSnap
    .data()
    .addresses.filter((addr) => addr.id !== addressId);

  await updateDoc(userRef, { addresses: updatedAddresses });
  return updatedAddresses;
};